(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('validPassword', function() {
    let total = 0;
    const upperCase = new RegExp('[A-Z]');
    const lowerCase = new RegExp('[a-z]');
    const numbers = new RegExp('[0-9]');
    const specialchars = new RegExp('([!,%,&,@,#,$,^,*,?,_,-,~,+])');
    const twoOrMoreUpperCase = new RegExp('[A-Z]', 'g');
    const twoOrMoreNumbers = new RegExp('[0-9]', 'g');
    const twoOrMoreNumbersSpecialchars = new RegExp('([!,%,&,@,#,$,^,*,?,_,-,~,+])', 'g');

    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, el, a, c) {
            c.$parsers.unshift(function(value) {
                checkStrength(value);
                return value;
            });

            scope.strength = function() {
                if (total <= 0) {
                    return 'EMPTY';
                } else if (total === 1) {
                    return 'POOR';
                } else if (total === 2) {
                    return 'VERYWEAK';
                } else if (total === 3) {
                    return 'WEAK';
                } else if (total === 4) {
                    return 'MEDIUM';
                } else if (total === 5) {
                    return 'GOOD';
                } else if (total > 5) {
                    return 'STRONG';
                }
            };

            function boolToInt(b) {
                return b ? 1 : 0;
            }

            function checkStrength(val) {
                total = 0;
                if (val !== null && val !== undefined) {
                    total = boolToInt(val.length >= 8) +
                        boolToInt(val.match(upperCase)) +
                        boolToInt(val.match(lowerCase)) +
                        boolToInt(val.match(numbers)) +
                        boolToInt(val.match(specialchars)) +
                        boolToInt((val.match(twoOrMoreUpperCase) || []).length > 1) +
                        boolToInt((val.match(twoOrMoreNumbers) || []).length > 1) +
                        boolToInt((val.match(twoOrMoreNumbersSpecialchars) || []).length > 1);
                }
                scope.$emit('passwordStrength', { strength: total, label: scope.strength() });
            }
        }
    };
});
})();
